<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-row>
        <v-col>
          <v-text-field
            v-model="varDate"
            prepend-icon="mdi-calendar"
            readonly
            dense
            solo
            style="min-width: 150px;"
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-date-picker
      v-model="date2"
      no-title
      @input="menu=false"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    date: {
      calendar: false,
      type: String
    }
  },
  watch: {
    varDate() {
      this.$emit('update:date', this.varDate)
    },
    date() {
      this.date2 = this.date
    }
  },
  computed: {
    varDate () {
      return this.date2 || this.date
    }
  },
  created() {
  },
  data() {
    return {
      menu: false,
      date2: ''
    }
  }
}
</script>
